/**
 * KEA Editor Events Bridge
 * - Centralise les événements éditeur Shopify et les re-propage en CustomEvents "kea:*"
 * - Évite le double-bind via un garde global
 * - Ne touche pas au mini-cart/BXGY ; aucun side-effect côté panier
 *
 * Astuce debug: localStorage.setItem('KEA_EDITOR_DEBUG','1') pour voir les logs, removeItem pour couper.
 */

const g = window;
if (!g.__KEA_EDITOR_EVENTS_BOUND__) {
  g.__KEA_EDITOR_EVENTS_BOUND__ = true;

  const DEBUG = (() => {
    try {
      return !!localStorage.getItem("KEA_EDITOR_DEBUG");
    } catch (_) {
      return false;
    }
  })();
  const log = (...a) => {
    if (DEBUG) console.log("[KEA:editor]", ...a);
  };

  const getSectionId = (el) =>
    el?.id && el.id.indexOf("shopify-section-") === 0
      ? el.id.replace("shopify-section-", "")
      : null;

  const emit = (name, el, extra = {}) => {
    const detail = { sectionEl: el || null, sectionId: el ? getSectionId(el) : null, ...extra };
    document.dispatchEvent(new CustomEvent(`kea:${name}`, { detail }));
    log("emit", name, detail);
  };

  // Événements natifs de l’éditeur
  const onSectionLoad = (e) => emit("reinit", e.target);
  const onSectionUnload = (e) => emit("destroy", e.target);
  const onSectionSelect = (e) => {
    // Visibilité / confort lors de la sélection
    e.target?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    emit("select", e.target);
  };
  const onSectionDeselect = (e) => emit("deselect", e.target);

  const onBlockSelect = (e) => {
    const sectionEl = e.target?.closest('[id^="shopify-section-"]');
    emit("block:select", sectionEl, {
      blockEl: e.target || null,
      blockId: e.target?.id?.replace("shopify-block-", "") || null,
    });
  };
  const onBlockDeselect = (e) => {
    const sectionEl = e.target?.closest('[id^="shopify-section-"]');
    emit("block:deselect", sectionEl, {
      blockEl: e.target || null,
      blockId: e.target?.id?.replace("shopify-block-", "") || null,
    });
  };

  // Binding
  document.addEventListener("shopify:section:load", onSectionLoad);
  document.addEventListener("shopify:section:unload", onSectionUnload);
  document.addEventListener("shopify:section:select", onSectionSelect);
  document.addEventListener("shopify:section:deselect", onSectionDeselect);
  document.addEventListener("shopify:block:select", onBlockSelect);
  document.addEventListener("shopify:block:deselect", onBlockDeselect);

  // Petite API publique (utile en debug)
  g.KeaEditor = {
    reinitAll() {
      document.querySelectorAll('[id^="shopify-section-"]').forEach((s) => emit("reinit", s));
    },
    emit(name, detail = {}) {
      document.dispatchEvent(new CustomEvent(`kea:${name}`, { detail }));
    },
    debug(on = true) {
      try {
        on
          ? localStorage.setItem("KEA_EDITOR_DEBUG", "1")
          : localStorage.removeItem("KEA_EDITOR_DEBUG");
      } catch (_) {}
    },
  };

  log("KEA Editor bridge bound");
}
